// extracted by mini-css-extract-plugin
export default {"ingress":"Ingress_ingress__gvK1A","lastLine":"Ingress_lastLine__xgEmn"};